import { apiService } from "./ApiService";

export const addGamepad = (
  streamId: string,
  name: string,
  vendorId: string,
  productId: string,
) => {
  return apiService.post({
    path: `v1/streams/${streamId}/gamepad`,
    body: {
      gamepad: {
        name,
        productId,
        vendorId,
      },
    },
    requiresAuthPolicy: "user",
  });
};
